export const Contact = () => {
    return (
        <section id="contact" className="py-5">
            <div className="container text-center">
                <h2 className="fw-bold mb-4">Contact Us</h2>
                <p className="text-muted mb-5">Ready to switch to solar? Get in touch for a free consultation.</p>

                <form className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <input type="text" className="form-control" placeholder="Your Name" required />
                        </div>
                        <div className="mb-3">
                            <input type="email" className="form-control" placeholder="Your Email" required />
                        </div>
                        <div className="mb-3">
                            <textarea className="form-control" rows={4} placeholder="Your Message" required></textarea>
                        </div>
                        <button type="submit" className="btn btn-warning btn-lg w-100 text-dark">Get A Quote</button>
                    </div>
                </form>
            </div>
        </section>
    )
}